import SideBarMenu, { SideBarMenuProps } from "./sidebar-menu";

export default SideBarMenu;
export type { SideBarMenuProps };
